import { IAction } from '../../state/types';
import * as actionsInterfaces from './types';
import * as actionTypes from './constants';

const defaultState: actionsInterfaces.IAuthState = {
    rehydrated: false
};

const appReducer = (
    state: actionsInterfaces.IAuthState = defaultState,
    action: {} | actionsInterfaces.ILoginAction | IAction
) => {
    switch ((action as IAction).type) {
        case actionTypes.LOGIN: {
            return { 
                authUser: (action as actionsInterfaces.ILoginAction).authUser,
                rehydrated: true
            };
        }
        case actionTypes.LOGOUT: {
            return {
                rehydrated: true
            };
        }
        case actionTypes.REHYDRATE_AUTH: {
            return {
                ...state,
                rehydrated: false
            };
        }
        case actionTypes.REHYDRATE_COMPLETE: {
            return {
                ...state,
                rehydrated: true
            };
        }
        default: {
            return state;
        }
    }
};

export default appReducer;
